<template>
  <TableGradient
      :title="$t('monitoramento.detalhe.table.vns_detalhados')"
      icon="fa-compact-disc"
      :items="vns"
      :fields="fields"
      :text-empty="$t('vns.listagem.table.empty')"
      table-data>
    <template v-slot:table-data-filters>
      <b-form class="row">
        <b-form-group :label="$t('monitoramento.detalhe.table.empresas')" label-class="text-white" class="col-md">
          <!--SelectCompanies @input="evt => filtrar('empresas', evt)"/-->
          <SelectComponent :options="companies" @input="evt => filtrar('company', 'name', evt)"/>
        </b-form-group>
        <b-form-group :label="$t('monitoramento.detalhe.table.unidades')" label-class="text-white" class="col-md">
          <SelectComponent :options="unidades" @input="evt => filtrar('unidades', evt)"/>
        </b-form-group>
        <b-form-group :label="$t('monitoramento.detalhe.table.tipo')" label-class="text-white" class="col-md">
          <SelectComponent :options="types"
                           @input="evt => filtrar('integration_destination', 'integration_type', evt)"/>
        </b-form-group>
        <b-form-group :label="$t('monitoramento.detalhe.table.equipamento')" label-class="text-white" class="col-md">
          <SelectComponent :options="equipments" @input="evt => filtrar('equipaments', evt)"/>
        </b-form-group>
        <b-form-group :label="$t('monitoramento.detalhe.table.com_alertas')" label-class="text-white" class="col-md">
          <SelectComponent :options="alerts" @input="evt => filtrar('alerts', evt)"/>
        </b-form-group>
      </b-form>
    </template>
    <template v-slot:cell(name)="linha">
      <router-link :to="{ name: 'vns.show', params: { id: linha.item.id } }">
        {{ linha.item.name }}
      </router-link>
    </template>
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.status, 'badge badge-danger': !linha.item.status}">
          <i :class="{'fas fa-check': linha.item.status, 'fas fa-ban': !linha.item.status}"/>
      </span>
    </template>
    <template v-slot:cell(printer_status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.printer_status, 'badge badge-danger': !linha.item.printer_status}">
          <i :class="{'fas fa-check': linha.item.printer_status, 'fas fa-ban': !linha.item.printer_status}"/>
      </span>
    </template>
    <template v-slot:cell(free)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.free, 'badge badge-danger': !linha.item.free}">
          <i :class="{'fas fa-check': linha.item.free, 'fas fa-ban': !linha.item.free}"/>
      </span>
    </template>
    <template v-slot:cell(dump)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.dump, 'badge badge-danger': !linha.item.dump}">
          <i :class="{'fas fa-check': linha.item.dump, 'fas fa-ban': !linha.item.dump}"/>
      </span>
    </template>
    <template v-slot:cell(debug)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.debug, 'badge badge-danger': !linha.item.debug}">
          <i :class="{'fas fa-check': linha.item.debug, 'fas fa-ban': !linha.item.debug}"/>
      </span>
    </template>
  </TableGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import TableGradient from "@/templates/TableGradient";
import SelectCompanies from "@/pages/vns/components/SelectCompanies";
import EmptyData from "@/components/EmptyData";
import SelectComponent from "@/components/SelectComponent";
import vSelect from 'vue-select'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Detail",
  components: {
    SelectCompanies,
    SelectComponent,
    TableGradient,
    EmptyData,
    vSelect,
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      vns_store: 'vns/all',
      isLoading: 'vns/isLoading'
    }),
    vns() {
      if (this.vns_store && Array.isArray(this.vns_store)) {
        return this.vns_store.filter(vns => {
          if (this.filtro.entity && this.filtro.attribute && this.filtro.value) {
            return vns[this.filtro.entity][this.filtro.attribute] === this.filtro.value
          } else {
            return vns
          }
        })
      }
      return []
    },
    types() {
      if (this.vns_store && Array.isArray(this.vns_store)) {
        let array = this.vns_store.map(vns => {
          if (vns.integration_destination && vns.integration_destination.integration_type) {
            return {
              label: vns.integration_destination.integration_type,
              value: vns.integration_destination.integration_type
            }
          }
        })
        // Remove os com value duplicados
        return array.filter((elem, index, self) => self.findIndex((t) => {
          return (t.value === elem.value)
        }) === index)
      }
      return []
    },
    companies() {
      if (this.vns_store && Array.isArray(this.vns_store)) {
        let array = this.vns_store.map(vns => {
          if (vns.company && vns.company.name) {
            return {
              label: vns.company.name,
              value: vns.company.name
            }
          }
        })
        // Remove os com value duplicados
        return array.filter((elem, index, self) => self.findIndex((t) => {
          return (t.value === elem.value)
        }) === index)
      }
      return []
    },
  },
  data() {
    return {
      fields: [
        {key: 'name', label: 'VNS'},
        {key: 'status', label: 'Status'},
        {key: 'company.name', label: this.$t('monitoramento.detalhe.table.empresa')},
        {key: 'company.unity', label: this.$t('monitoramento.detalhe.table.unidade')},
        {key: 'nick_name', label: this.$t('monitoramento.detalhe.table.apelido')},
        {key: 'internal_ip', label: this.$t('monitoramento.detalhe.table.ip_interno')},
        {key: 'external_ip', label: this.$t('monitoramento.detalhe.table.ip_externo')},
        {key: 'cpu_temperature', label: 'CPU'},
        {key: 'modem_data_consumption', label: this.$t('monitoramento.detalhe.table.latencia')},
        {key: 'printer_status', label: this.$t('monitoramento.detalhe.table.impressora')},
        {key: 'recieved', label: this.$t('monitoramento.detalhe.table.recebidos')},
        {key: 'sended', label: this.$t('monitoramento.detalhe.table.enviados')},
        {key: 'bridge', label: 'Bridge Version'},
        {key: 'transfer', label: 'Transfer Version'},
        {key: 'monitor', label: 'Monitor Version'},
        {key: 'free', label: this.$t('monitoramento.detalhe.table.disco_livre')},
        {key: 'dump', label: 'Dump'},
        {key: 'debug', label: 'Debug'}
      ],
      filtro: {
        entity: null,
        attribute: null,
        value: null
      },
      unidades: [
        {label: this.$t('monitoramento.detalhe.table.filtro_indisponivel'), value: null}
      ],
      alerts: [
        {label: this.$t('monitoramento.detalhe.table.filtro_indisponivel'), value: null}
      ],
      equipments: [
        {label: this.$t('monitoramento.detalhe.table.filtro_indisponivel'), value: null}
      ],
    }
  },
  methods: {
    ...mapActions([
      'vns/listAll'
    ]),
    filtrar(entity, attribute, selected) {
      this.filtro.entity = null
      this.filtro.attribute = null
      this.filtro.value = null
      if (selected) {
        this.filtro.entity = entity
        this.filtro.attribute = attribute
        this.filtro.value = selected.value
      }
    }
  },
  async mounted() {
    await this['vns/listAll']()
  },
}
</script>

<style lang="scss" scoped>
/deep/ .badge-danger {
  background-color: #ffe1de;
  color: #e74a3b;
}

/deep/ .badge-success {
  background-color: #d8fbee;
  color: #1cc88a;
}
</style>
